import script from "./QrRedirectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QrRedirectPage.vue?vue&type=script&setup=true&lang=js"

import "./QrRedirectPage.vue?vue&type=style&index=0&id=e516a208&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e516a208"]])

export default __exports__